<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <filter-manager
          v-model="searchModel.filters"
          ref="reportFilterRef"
          :filters="filterManagerConfig"
          @search="this.downloadReport"
          items-container-class="flex-wrap"
          :display-advanced="false"
          class="search-bar"
          search-text="Procesar"
          search-icon="fa fa-sync"
          search-container-class="btn-process-custom"
          :is-advanced="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import CodeApiServices from '@/services/api/code.api'
import locationServices from '@/services/api/location.api'
import reportApi from '@/modules/report/api'
import DocumentsService from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    searchModel: {
      collections: {
        status: [],
        csee: [],
        schoolType: [],
        municipalities: [],
        commentTypes: [],
        schools: [],
      },
      filters: {
        status: null,
        csee: null,
        municipality: null,
        school: null,
        schoolType: null,
        sie: null,
        academicYear: null,
      },
    },
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Lista de Estudiantes en MiPE',
      routes: ['Informes', 'Lista de Estudiantes en MiPE'],
    },
    results: [],
  }),
  computed: {    
    filterManagerConfig() {
      return [
        {
          name: 'status',
          options: this.searchModel.collections.status,
          initialValue: null,
          component: 'custom-drop-down',
          placeholder: 'Seleccionar',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Estatus',
          class: 'col-md-3',
        },
        {
          name: 'csee',
          component: 'custom-drop-down',
          options: this.searchModel.collections.csee,
          label: 'CSEE',
          placeholder: 'Seleccionar',
          fieldName: 'name',
          fieldKey: 'id',
          onChanged: this.onChangedCsee,
          initialValue: null,
          class: 'col-md-3',
          validations: (this.searchModel.filters.csee === null || this.searchModel.filters.csee === undefined)&& this.searchModel.filters.sie === null ? 'required' : '',
          error: 'Favor de seleccionar un CSEE.',
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          options: this.searchModel.collections.municipalities,
          label: 'Municipio',
          placeholder: 'Seleccionar',
          fieldName: 'name',
          fieldKey: 'id',
          onChanged: this.onChangedMunicipality,
          initialValue: null,
          class: 'col-md-3',
        },
        {
          name: 'school',
          component: 'custom-drop-down',
          options: this.searchModel.collections.schools,
          initialValue: null,
          label: 'Escuela',
          placeholder: 'Seleccionar',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-md-3',
        },
        {
          name: 'sie',
          component: 'CustomInput',
          placeholder: 'Escriba Número de SIE o Registro',
          label: 'SIE / Registro',
          icon: 'fa fa-search orange-icon',
          value: this.searchModel.filters.sie,
          leftIcon: true,
          type: 'text',
          class: 'col-md-3',
          validations: (this.searchModel.filters.csee === null || this.searchModel.filters.csee === undefined) && this.searchModel.filters.sie === null ? 'required' : '',
          error: 'Favor de documentar un Número de SIE o Registro.',
        },
        {
          name: 'schoolType',
          component: 'custom-drop-down',
          options: this.searchModel.collections.schoolType,
          label: 'Tipo de Escuela',
          placeholder: 'Seleccionar',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-md-3',
        },
      ]
    },
  },
  async mounted() {
    this.initFilters()
  },
  methods: {
    async initFilters() {
      await CodeApiServices.GetReportStudentSearchInitialFilterValues()
        .then((res) => {
          this.searchModel = res.data;      
        })
        .then(() => {
          const inputs = ['csee',['municipality', 'municipalities'],['school','schools']];
          inputs.forEach(item => {
            const key =  Array.isArray(item) ? item[0] : item;
            const value = Array.isArray(item) ? item[1] : item;
            this.searchModel.filters[key] = this.searchModel.collections[value].filter(
                        (s) => s.selected
                      )[0];
          });
        })
        .catch()
    },

    async onFilterHandler() {},
    async onChangedCsee() {
      const centerId = this.searchModel.filters.csee?.id;
      const academicYearId = this.searchModel.filters.academicYear?.id;

      this.searchModel.filters.municipality = null;
      this.searchModel.collections.municipalities = [];
      this.searchModel.filters.school = null;
      this.searchModel.collections.schools = [];

      //cargamos municipalidad
      locationServices
        .getMunicipalities({
          AcademicYearId: academicYearId,
          CenterId: centerId,
        })
        .then((res) => {
          this.searchModel.collections.municipalities = res.data;
          this.searchModel.filters.municipality = this.searchModel.collections.municipalities.filter(
            (s) => s.selected
          )[0];
        })

        //cargamos escuelas
      locationServices
        .getSchools({
          AcademicYearId: academicYearId,
          CenterId: centerId,
        })
        .then((res) => {
          this.searchModel.collections.schools = res.data;
          this.searchModel.filters.school = this.searchModel.collections.schools.filter(
            (s) => s.selected
          )[0];
        })
    },
    async onChangedMunicipality() {
      const academicYearId = this.searchModel.filters.academicYear?.id;
      const municipalityId = this.searchModel.filters.municipality?.id;

      this.searchModel.filters.school = null;
      this.searchModel.collections.schools = [];

      //obtener escuela
      locationServices
        .getSchools({
          AcademicYearId: academicYearId,
          MunicipalityId: municipalityId,
        })
        .then((res) => {
          this.searchModel.collections.schools = res.data;
          this.searchModel.filters.school = this.searchModel.collections.schools.filter(
            (s) => s.selected
          )[0];
        })
    },

    async downloadReport() {
      const isValid = await this.$refs.reportFilterRef.$refs.formValidator.validate();

      if (isValid) {
        reportApi
          .getReport('getStudentList', {
            StudentStatusId: this.searchModel.filters.status?.id,
            CenterId: this.searchModel.filters.csee?.id,
            LocationSchoolId: this.searchModel.filters.school?.id,
            MunicipalityId: this.searchModel.filters.municipality?.id,
            SchoolType: this.searchModel.filters.schoolType?.id,
            SieRegisterId: this.searchModel.filters.sie,
          })
          .then((res) => {
            DocumentsService.Download(res.data);
          })
      }
    },
  },
}
</script>

<style scope>
.btn-process-custom {
	position: absolute !important;
  bottom: 17px !important;
  right: 15px !important;
}
</style>